import api from './api';

/**
 * Customer notification channels -- `/api/v1/communications/channel-preferences/`
 * (board #394). Four channels x three categories are stored; `delivering` names
 * the channels that actually send today (email only). The rest are saved for
 * when a provider is wired.
 */

export type ChannelCategory = 'quotes' | 'policy_documents' | 'renewal_reminders';
export type ChannelName = 'email' | 'sms' | 'whatsapp' | 'push';
export type ChannelGrid = Record<ChannelCategory, Record<ChannelName, boolean>>;

export interface ChannelPreferences {
  categories: ChannelCategory[];
  channels: ChannelName[];
  delivering: ChannelName[];
  preferences: ChannelGrid;
}

export const channelPreferencesApi = {
  async get(): Promise<ChannelPreferences> {
    const { data } = await api.get<ChannelPreferences>('/communications/channel-preferences/');
    return data;
  },

  async update(preferences: Partial<Record<ChannelCategory, Partial<Record<ChannelName, boolean>>>>): Promise<ChannelPreferences> {
    const { data } = await api.put<ChannelPreferences>('/communications/channel-preferences/', { preferences });
    return data;
  },
};
